import DateBuilder from '../../lib/DateBuilder';

type Props = {
    date: string;
    timezoneName?: string;
    locale?: string | null;
};

/**
 * Label date
 */
export function SttLabelDate({
    date,
    timezoneName = 'Europe/Madrid',
    locale = null,
}: Props): React.ReactElement {
    return <>{new DateBuilder(date, timezoneName, locale).dmy()}</>;
}
